import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction } from './interface/apiInterface';
import { IInitialState, ITaxData } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: false,
  dateSearch: {
    start: '',
    end: '',
  },
  taxs: [],
};

function checkArray(props: any) {
  if (props === undefined) {
    return [];
  }
  return props;
}

export const getcashInFromApi = createAction(
  '@CASHIN/ANALYTICDATA/GET_ANALITIC_DATA_FROM_API'
);

export const disableCashInFromApi = createAction(
  '@CASHIN/ANALYTICDATA/GET_ANALITIC_DATA_FROM_DISABLE_API'
);

export const gotcashInFromApi = createAction<any>(
  '@CASHIN/ANALYTICDATA/GOT_ANALITIC_DATA_FROM_API'
);

export const gotcashInPartnerFromApi = createAction<any>(
  '@CASHIN/ANALYTICDATA/GOT_ANALITICPARTNER_DATA_FROM_API'
);

export const gotErrorFromcashInApi = createAction(
  '@CASHIN/ANALYTICDATA/GOT_ERROR_FROM_ANALITIC_DATA_API'
);

const cashInReducer = createReducer(INITIAL_STATE, {
  [getcashInFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    gotSuccess: false,
    partner: false,
    gotError: false,
    isLoading: true,
  }),
  [disableCashInFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    gotSuccess: false,
    partner: false,
    gotError: false,
    isLoading: false,
  }),
  [gotcashInFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    isLoading: false,
    gotError: false,
    partner: false,
    taxs: checkArray(action.payload).map((tax: ITaxData) => {
      const data: ITaxData = {
        cod_msg: tax.cod_msg,
        name_client: tax.name_client,
        document: tax.document,
        account_with_digit: tax.account_with_digit,
        value: tax.value,
        percent_tax_pix: tax.percent_tax_pix,
        percent_tax_ted: tax.percent_tax_ted,
        percent_tax_boleto: tax.percent_tax_boleto,
        percent_tax_domicilio: tax.percent_tax_domicilio,
      };
      return data;
    }),
  }),

  [gotErrorFromcashInApi.type]: (state) => ({
    ...state,
    gotSuccess: false,
    isLoading: false,
    partner: false,
    gotError: true,
  }),
});

export default cashInReducer;
